import React from 'react';
import { motion } from 'framer-motion';

const Hero = ({ profile }) => {
  return (
    <section className="relative min-h-[70vh] flex flex-col justify-center pt-24 pb-20">
      <div className="container mx-auto px-6 md:px-12 max-w-6xl">
        <div className="flex flex-col gap-8 items-start">
          
          {/* Profile Section (Top) */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="relative shrink-0"
          >
            <div className="relative">
              {/* Profile Image */}
              <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden bg-white border border-gray-200 relative z-10">
                 <img 
                   src="https://customer-assets.emergentagent.com/job_design-clarity-3/artifacts/274r4p26_image.png" 
                   alt="Sanket Daware" 
                   className="w-full h-full object-cover"
                 />
              </div>
            </div>
          </motion.div>

          {/* Text Content (Bottom) */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex-1 max-w-4xl"
          >
            {/* Main Heading with Fraunces Font & Specific Color */}
            <h1 className="text-4xl md:text-5xl lg:text-[3.5rem] leading-[1.3] font-serif text-[#414141] mb-8 text-left">
              Hello! I am Sanket Daware, <br />
              Currently designing <span className="italic">@Narayana Health, Analytics Division.</span>
            </h1>

            {/* Bottom Info Line */}
            <div className="flex flex-col md:flex-row md:items-center gap-4 text-[#414141]/70 text-lg font-sans">
               <span>AI Driven UX · Enterprise SaaS · Data Intensive Workflow</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
